module.exports = __webpack_public_path__ + "static/media/sensable_15.417ef225.gif";